import axios from 'axios';
import store from "../store";
import moment from "moment";

const PREFIJO="/api/PrsRlc/";
const PREFIJO2="/api/CtvCnm/";
const PREFIJO3="/api/PrsCtv/";
const PASIVOS="/api/PrsPsv/";
const INGRESOS="/api/PrsNgr/";
const GASTOS="/api/PrsGst/";
const RBANCARIAS= "/api/RfnBnc/";
const RPERSONALES= "/api/RfnPrsn/";
const PEXPUESTA= "/api/CrgPp/";
const FAMILIAEX= "/api/FmlrPp/";

export default {
    datosPersonales(){
        const dto={
            id:store.getters.getCotizacion.id,
        };
        return axios.post(`${PREFIJO}VmSlId`,dto);
    },
    datosPersonalesSugerencia() {
        const dto={
            dt1: store.getters.getDni, //Identificacion
            ndt1: process.env.VUE_APP_PAIS_KEY, //IdPais
            id: store.getters.getCotizacion.id,
            ndt2: store.getters.getCotizacion.ndt5,
        };
        return axios.post(`${PREFIJO}VmSlRcm`,dto);
    },
    validarDatos(){
        const dto={
            id:store.getters.getCotizacion.id
        };
        return axios.post(`${PREFIJO}VmVldNg`,dto);
    },
    actualizacionPersonales(formulario,id,datosCargados,solicitanto){
        let dto={};
        if(id===1){
            dto={
                id:store.getters.getCotizacion.id,
                ddt1:moment(formulario.fecha,"DD/MM/YYYY").toISOString(),
                dt1:formulario.dni,
                dt2: formulario.nombre2 ? `${formulario.nombre1} ${formulario.nombre2}` : formulario.nombre1,
                dt3: formulario.apellido2 ? `${formulario.apellido1} ${formulario.apellido2}` : formulario.apellido1,
                dt6:formulario.origenFondo,
                dt7:formulario.correo,
                dt16:formulario.telefono,
                dt17:formulario.celular,
                dt22:formulario.lugar,
                bdt1:formulario.pep,
                bdt2:formulario.funcionarios,
                bdt3:formulario.cargoPublico,
                ndt1:formulario.tipoDni.id,
                ndt3:formulario.tipo.id,
                ndt4:formulario.cargas,
                ndt6:formulario.estado.id,
                ndt7:formulario.genero.id,
                ndt8:formulario.desde,
                ndt9:formulario.hasta,
                dt4:formulario.nombreFuncionario,
                dt5:formulario.nombrePublico,
                ndt12:formulario.nacionalidad.id,
                ndt13:store.getters.getCotizacion.ndt5,
                //ndt22:Patrimonio Neto
                elements4:[
                    {
                        ndt2:formulario.ciudad.id,
                        ndt3:formulario.parroquia.id,
                        dt1:formulario.calle1,
                        dt2:formulario.calle2,
                        dt3:formulario.numeroCalle,
                        dt4:formulario.referencia,
                        dt5:formulario.barrio,
                        dt6:formulario.manzana,
                        dt7:formulario.direccion.id,
                    }
                ]
            };
            return axios.post(`${PREFIJO}VmCrPrs`,dto);
        } else {
            dto = {
                id:store.getters.getCotizacion.id,
                ndt21:datosCargados.ndt17,
                ddt2:moment(formulario.fecha,"DD/MM/YYYY").toISOString(),
                dt11:formulario.dni,
                dt12:`${formulario.nombre1} ${formulario.nombre2}`,
                dt13:`${formulario.apellido1} ${formulario.apellido2}`,
                dt21:formulario.telefono,
                dt29:formulario.correo,
                dt18:formulario.celular,
                bdt5:formulario.pep,
                bdt6:formulario.funcionarios,
                bdt7:formulario.cargoPublico,
                ndt6:solicitanto.estado.id,
                ndt11:formulario.tipoDni.id,
                ndt13:store.getters.getCotizacion.ndt5,
                ndt15:formulario.tipo.id,
                ndt14:formulario.cargas,
                ndt17:formulario.genero.id,
                ndt20:formulario.nacionalidad.id,
                ndt18:formulario.desde,
                ndt19:formulario.hasta,
                dt14:formulario.nombreFuncionario,
                dt15:formulario.nombrePublico,
                elements4:[
                    {
                        ndt2:solicitanto.ciudad.id,
                        ndt3:solicitanto.parroquia.id,
                        dt1:solicitanto.calle1,
                        dt2:solicitanto.calle2,
                        dt3:solicitanto.numeroCalle,
                        dt4:solicitanto.referencia,
                        dt5:solicitanto.barrio,
                        dt6:solicitanto.manzana,
                        dt7:solicitanto.direccion.id,
                    }
                ]
            };
            return axios.post(`${PREFIJO}VmCrPrnt`,dto);
        }
    },
    actualizacionLaborales(formulario,tipo,ide){
        const dto={
            // dt1:store.getters.getUsuario.dt1,
            ndt1:tipo===1 ? store.getters.getCotizacion.id : ide,
            elements:[
                {
                    dt1:formulario.empresa,
                    dt2:formulario.cargo,
                    dt3:formulario.telefonoE,
                    dt4:formulario.emailE,
                    dt6:formulario.direccionE,
                    dt7:formulario.ruc,
                    dt8:formulario.razon,
                    ndt1:formulario.ciudad.id,
                    ndt2:formulario.provincia.id,
                    ndt3:process.env.VUE_APP_PAIS_KEY,
                    ndt5:formulario.tipoAc.id,
                    ndt6:formulario.meses,
                    ndt7:formulario.anios,
                    ndt8:formulario.sector.id,
                    ndt9:formulario.relacion.id,//relacion laboral
                }
            ]
        };
        return axios.post(`${PREFIJO2}VmUpCtv`,dto);
    },
    actualizacionActivos(formulario,idForm,idCon){
        const dto = {
            ndt1:idForm === 1 ? store.getters.getCotizacion.id : idCon,
            elements:formulario,
        };
        return axios.post(`${PREFIJO3}VmUpCtv`,dto);
    },
    actualizacionPasivos(formulario,idForm,idCon){
        const dto = {
            ndt1:idForm === 1 ? store.getters.getCotizacion.id : idCon,
            elements:formulario,
        };
        return axios.post(`${PASIVOS}VmUpPsv`,dto);
    },
    actualizacionIngresos(formulario,idForm,idCon){
        const dto = {
            ndt1:idForm === 1 ? store.getters.getCotizacion.id : idCon,
            elements:formulario,
        };
        return axios.post(`${INGRESOS}VmUpIng`,dto);
    },
    actualizacionGastos(formulario,idForm,idCon){
        const dto = {
            ndt1:idForm === 1 ? store.getters.getCotizacion.id : idCon,
            elements:formulario,
        };
        return axios.post(`${GASTOS}VmUpGst`,dto);
    },
    actualizacionReferenciasBancarias(formulario){
        const dto = {
            ndt1:store.getters.getCotizacion.id,
            elements:formulario,
        };
        return axios.post(`${RBANCARIAS}VmUpRfc`,dto);
    },
    actualizacionReferenciasPersonales(formulario){
        const dto = {
            ndt1:store.getters.getCotizacion.id,
            elements:formulario,
        };
        return axios.post(`${RPERSONALES}VmUpRfc`,dto);
    },
    actualizacionPersonaExpuesta(formulario){
        const dto = {
            ndt1:store.getters.getCotizacion.id,
            elements:formulario,
        };
        return axios.post(`${PEXPUESTA}VmUpCrg`,dto);
    },
    actualizacionFamiliaExpuesta(formulario){
        const dto = {
            ndt1:store.getters.getCotizacion.id,
            elements:formulario,
        };
        return axios.post(`${FAMILIAEX}VmUpFmlr`,dto);
    },
};
